import HeaderRouteIndicator from "./../../Molecules/HeaderRouteIndicator/HeaderRouteIndicator";
import CommonQuestionsHeader from "./../../Organisms/CommonQuestionsHeader/CommonQuestionsHeader";
import CommonQuestionsInstallation from "../../Organisms/CommonQuestionsInstallation/CommonQuestionsInstallation";
import content from "./content"
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

const CommonQuestions = () => {
  const {language} = useLanguageCtx();
  const { dropdownHeader } = useScrollCtx();

  return (
    <>
      <ChangeableHeaderV2 basic appearSecondNavbar={dropdownHeader} />
      <HeaderRouteIndicator route={content[language].route} />
      <CommonQuestionsHeader />
      <CommonQuestionsInstallation />
    </>
  );
};

export default CommonQuestions;
